import { TabStyles, TextFieldWidget, TextInputType } from '@tableau/widgets';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';

export type AddFileServerPasswordFieldProps = Readonly<{
  onPasswordChange: (password: string) => void;
  password: string;
  isEditPassword: boolean;
}>;

export function AddFileServerPasswordField(props: AddFileServerPasswordFieldProps) {
  return (
    <TextFieldWidget
      label={props.isEditPassword ? Messages.dataConnectSiteSettingsDomainFileServerChangePassword() : Messages.dataConnectSiteSettingsDomainFileServerPassword()}
      onChange={e => props.onPasswordChange(e.target.value)}
      onClear={() => props.onPasswordChange('')}
      placeholder={''}
      testId={'fileserver-password-widget'}
      kind={'outline'}
      className={textFieldClass}
      style={{ width: '100%' }}
      type={TextInputType.Password}
    />
  );
}
const textFieldClass = cssClass('fileserver-password-text-field', 'root', {
  width: '100%',
  marginTop: TabStyles.Spacing.LargeSpace,
  marginBottom: TabStyles.Spacing.LargeSpace,
});
